(function () {
  var adsId = "AW-800671982";
  var conversionLabel = adsId + "/lnHhCNDGuPUYEO6R5f0C";
  var primaryWhatsAppNumber = "60143612241";
  var scriptRequested = false;

  function isPrimaryWhatsAppLink(url) {
    var match = String(url).match(/^https?:\/\/wa\.me\/([^?#]+)/i);
    return Boolean(
      match && match[1].replace(/\D/g, "") === primaryWhatsAppNumber,
    );
  }

  function initializeGoogleTag() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    if (scriptRequested) {
      return;
    }

    scriptRequested = true;
    var script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + adsId;
    document.head.appendChild(script);
    window.gtag("js", new Date());
    window.gtag("config", adsId, { send_page_view: false });
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest("a[href]");

    if (!link || !isPrimaryWhatsAppLink(link.href)) {
      return;
    }

    event.preventDefault();
    initializeGoogleTag();

    var destination = link.href;
    var navigated = false;
    var navigate = function () {
      if (navigated) {
        return;
      }
      navigated = true;
      window.location.assign(destination);
    };

    window.gtag("event", "conversion", {
      send_to: conversionLabel,
      event_callback: navigate,
    });
    setTimeout(navigate, 800);
  });
})();
